/**
 * Figma: https://www.figma.com/design/XwMQV9iBJ1Ec4sOzWMEZcK/-Dev--Customer-Hub-2.3-%E2%80%93-Phase-1?node-id=2353-157707&m=dev
 */

import { useLabel } from '../../../i18n'
import type { Address, Order } from '../types'

interface InfoRowProps {
  title: string
  children: React.ReactNode
}

const InfoRow = ({ title, children }: InfoRowProps) => (
  <div className="flex flex-col gap-4 border-b border-border-tertiary pt-[19px] pb-24 last:border-b-0">
    <span className="text-base leading-base font-medium text-text">
      {title}
    </span>
    <div className="text-base leading-base font-light text-text">
      {children}
    </div>
  </div>
)

const AddressBlock = ({ address }: { address: Address }) => (
  <div className="flex flex-col text-base leading-base">
    {address.name && <span>{address.name}</span>}
    {address.street && <span>{address.street}</span>}
    {address.city && <span>{address.city}</span>}
    {address.country && <span>{address.country}</span>}
    {address.phone && <span>{address.phone}</span>}
  </div>
)

interface PurchaseDetailsProps {
  order: Order
  isReturnDetails?: boolean
}

export default function PurchaseDetails({
  order,
  isReturnDetails = false,
}: PurchaseDetailsProps) {
  const t = useLabel()

  return (
    <div className="flex flex-col gap-16">
      <h2 className="text-xl leading-xl lg:text-2xl lg:leading-2xl font-medium text-text tracking-heading">
        {isReturnDetails
          ? t('orderList.purchaseDetails.returnTitle')
          : t('orderList.purchaseDetails.title')}
      </h2>
      <div className="overflow-hidden rounded-lg border border-border-tertiary px-[19px] bg-surface">
        {order.shippingAddress && (
          <InfoRow title={t('orderList.purchaseDetails.shippingAddress')}>
            <AddressBlock address={order.shippingAddress} />
          </InfoRow>
        )}
        {order.billingAddress && order.location?.isWebStore && (
          <InfoRow title={t('orderList.purchaseDetails.billingAddress')}>
            <AddressBlock address={order.billingAddress} />
          </InfoRow>
        )}
        <InfoRow title={t('orderList.purchaseDetails.orderDate')}>
          <span>{order.orderDate}</span>
        </InfoRow>
        <InfoRow title={t('orderList.purchaseDetails.orderedAt')}>
          <span>
            {order.location?.isWebStore
              ? t('orderList.purchaseDetails.online')
              : order.orderedAt}
          </span>
        </InfoRow>
        <InfoRow title={t('orderList.purchaseDetails.orderNumber')}>
          <span>{order.orderNumber}</span>
        </InfoRow>
      </div>
    </div>
  )
}
